import { Instance, types } from 'mobx-state-tree';

export const AttachmentCacheEntryModel = types.model(
  'AttachmentCacheEntryModel',
  {
    url: types.optional(types.maybeNull(types.string), null),
    // Уменьшенная копия для превью (сайдбар/грид/полоска вьювера) — тяжёлый
    // оригинал из url туда не годится, см. thumbnail.ts
    thumbUrl: types.optional(types.maybeNull(types.string), null),
    size: types.optional(types.maybeNull(types.number), null),
    filename: types.optional(types.maybeNull(types.string), null),
    status: types.optional(
      types.enumeration('AttachmentCacheStatus', [
        'loading',
        'loaded',
        'error',
      ]),
      'loading'
    ),
  }
);

export type TAttachmentCacheEntry = Instance<typeof AttachmentCacheEntryModel>;

export const attachmentCacheKey = (
  chatId: number,
  messageId: string,
  attachmentId: string
): string => `${chatId}:${messageId}:${attachmentId}`;
